import { Pipe, PipeTransform } from '@angular/core';

import { DeliveryType, MealDeliveryAreaTiming } from 'src/app/models';

@Pipe({
  name: 'mealDeliveryTiming'
})
export class MealDeliveryTimingPipe implements PipeTransform {
  constructor() {}

  private static getFormattedHour(
    timing: MealDeliveryAreaTiming,
    portion: string
  ): string {
    const hour = ('0' + timing[`${portion}_hr`]).slice(-2);
    const minute = ('0' + timing[`${portion}_min`]).slice(-2);
    return `${hour}:${minute} ${timing[`${portion}_am`] ? 'AM' : 'PM'}`;
  }

  static formatTime(
    timing: MealDeliveryAreaTiming,
    deliveryType: DeliveryType
  ): string {
    if (!timing?.id) {
      return 'ASAP';
    }

    const formattedFrom = this.getFormattedHour(timing, 'from');

    if (deliveryType === DeliveryType.DELIVERY) {
      return `${formattedFrom} - ${this.getFormattedHour(timing, 'to')}`;
    } else {
      return formattedFrom;
    }
  }

  transform(
    timing: MealDeliveryAreaTiming,
    deliveryType: DeliveryType
  ): string {
    return MealDeliveryTimingPipe.formatTime(timing, deliveryType);
  }
}
